import { render, staticRenderFns } from "./ShortableDispatch.vue?vue&type=template&id=dd7578c0"
import script from "./ShortableDispatch.vue?vue&type=script&lang=js"
export * from "./ShortableDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports